// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDdg2hIzwlLRphE1WEjc1xvYRcyWuojPCE",
    authDomain: "kdramatracker-f2512.firebaseapp.com",
    projectId: "kdramatracker-f2512",
    storageBucket: "kdramatracker-f2512.appspot.com",
    messagingSenderId: "248696769633",
    appId: "1:248696769633:web:90c45b314d9603961a6e20",
    measurementId: "G-6Y418JCKT9"
};
const app = initializeApp(firebaseConfig);

// Initialize other Firebase services after app initialization
const analytics = getAnalytics(app);
const auth = getAuth(app); // Move this after app initialization
const db = getFirestore(app);
const storage = getStorage(app);
export { app, auth, db, storage, analytics };